import PhotoSwipe from '@karishka/photoswipe/dist/photoswipe';
import PhotoSwipeUI_Default from '@karishka/photoswipe/dist/photoswipe-ui-default';

class ProjectorPhotoSwipe {
  constructor({ items = [], options = {} }) {
    if (!items) throw Error('Images config is reqired!');
    this.options = {
      index: 0,
      history: false,
      focus: false,
      showAnimationDuration: 0,
      hideAnimationDuration: 0,
      shareEl: false,
      ...options,
    };
    this.node = document.querySelector('.pswp');
    this.items = [...items];
    this.init();
  }

  init() {
    const gallery = new PhotoSwipe(this.node, PhotoSwipeUI_Default, this.items, this.options);
    gallery.init();
  }
}

export default ProjectorPhotoSwipe;
